import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // 确保路径正确
import 'vant/lib/index.css';
import 'element-plus/dist/index.css';

import { Button, Card, Form, Field, CellGroup, NumberKeyboard } from 'vant';
import ElementPlus from 'element-plus';

const app = createApp(App);

app.use(router);
app.use(Button);
app.use(Card);
app.use(Form);
app.use(Field);
app.use(CellGroup);
app.use(NumberKeyboard);
app.use(ElementPlus);

app.mount('#app');